import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteDesignTagDocument } from './delete.generated';

export const useDeleteDesignTag = (options: ApiOptions<typeof DeleteDesignTagDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(DeleteDesignTagDocument, {
    ...useNotifications(DeleteDesignTagDocument, {
      failure: t('api.design_tags.delete_error'),
      success: t('api.design_tags.delete_success'),
    }),
    ...options,
  });
};
